import { getSwiperInstance } from '@/helpers/swiperInstance';
import { checkVolumeButtonState } from '@/helpers/volumeControl';
import { animateCurrentProgressBar } from '@/modules/actions/headerLineDuration';
import { navigateMediaItem } from '@/helpers/navigateMediaItem';
import { mobileAutoPlayNextAction } from '@/modules/actions/mobile/mobileAutoPlayNextAction';
import { trackStoreeelEvent } from "@/helpers/trackStoreeelEvent";
import localStorageRepositories from "@/plugins/localStorageRepositories";
import pauseImg from '@/assets/images/pause-fill.svg';
import { updateCtaButtonAction } from '@/modules/actions/mobile/updateCtaButtonAction';
import { clearImageTimer } from '@/helpers/mediaUtils';

export const groupSwipeAction = () => {
  const swiper = getSwiperInstance();

  if (window.storeeelItems.frame === "circle") {
    // スライド毎の進捗開始の多重起動防止用シーケンス
    window._storeeelProgressSeq = (window._storeeelProgressSeq || 0);
    const startProgressForActive = () => {
      const swiper = getSwiperInstance();
      const allSlides = document.querySelectorAll('.storeeel-swiper-group-wrapper .swiper-slide');
      const currentSlide = allSlides[swiper.activeIndex];
      const video = currentSlide.querySelector('.slide-media-wrapper video');
      const image = currentSlide.querySelector('.slide-media-wrapper img');

      // 全メディア中の開始インデックスを算出（グループ型対応）
      const items = window.storeeelItems;
      let mediaLnegth = 0;
      for (let i = 0; i < swiper.activeIndex; i++) {
        mediaLnegth += items.contentGroups[i].contents.length;
      }
      mediaLnegth += (window.currentGroupMediaIndex || 0);

      if (video && video.style.display !== 'none') {
        if (video.duration) {
          animateCurrentProgressBar(video.duration, mediaLnegth);
          video.classList.add('active');
        }
      } else if (image && image.style.display !== 'none') {
        animateCurrentProgressBar(5, mediaLnegth);
        image.classList.add('active');
      }
    };

    swiper.on('slideChange', () => {
      const allSlides = document.querySelectorAll('.storeeel-swiper-group-wrapper .swiper-slide');
      const currentSlide = allSlides[swiper.activeIndex];
      const currentVideo = currentSlide.querySelector('.storeeel-movie');
      const currentImage = currentSlide.querySelector('.storeeel-media-image');

      // 動画と画像からactiveクラスを外す
      if (currentVideo) {
        currentVideo.classList.remove('active');
      }
      if (currentImage) {
        currentImage.classList.remove('active');
      }
      clearImageTimer(); // 画像タイマーをクリア
      window.moviePosition = 0;
      window.iconId = window.storeeelItems.contentGroups[swiper.activeIndex].id;
      const contents = navigateMediaItem();
      const targetMedia = contents[0]
      const mimeType = targetMedia.mediaAsset.attachmentData.metadata.mime_type;

      // このスライド用の進捗起動シーケンスを更新
      window._storeeelProgressSeq += 1;
      const progressSeq = window._storeeelProgressSeq;

      // すべての動画を停止・リセットし、スライドから active クラスを外す
      document.querySelectorAll('.storeeel-swiper-group-wrapper .swiper-slide').forEach((slide) => {
        slide.classList.remove('active');
        const video = slide.querySelector('video');
        if (video && video !== currentVideo) {
          video.pause();
          video.currentTime = 0;
        }
        // 現在のスライドに active クラスを追加し、動画を再生
        currentSlide.classList.add('active');
        if (mimeType.includes('video')) {
          currentVideo.currentTime = 0;
          currentVideo.src = targetMedia.mediaAsset.mediaUrl;
          currentVideo.load(); // 明示的にロード
          currentVideo.style.display = 'block';

          // 進捗バー開始のフォールバック（transitionEndを待たない）
          const onCanPlay = () => {
            currentVideo.removeEventListener('canplay', onCanPlay);
            // 最新スライドであることを確認
            if (progressSeq === window._storeeelProgressSeq) {
              startProgressForActive();
            }
          };
          currentVideo.addEventListener('canplay', onCanPlay, { once: true });
          // すでに再生可能なら即時実行
          if (currentVideo.readyState >= 3) {
            onCanPlay();
          }

          const image = currentSlide.querySelector('.storeeel-media-image');
          if (image) {
            image.style.display = 'none';
          }
          if (currentImage) {
            currentImage.style.display = 'none';
          }
          currentVideo.onloadeddata = () => {
            currentVideo.play().catch(() => {
            });
            checkVolumeButtonState();
          };
          checkVolumeButtonState();
        } else if (mimeType.includes('image')) {
          currentImage.src = targetMedia.mediaAsset.mediaUrl;
          currentImage.style.display = 'block';

          // 画像は即座に進捗開始（transitionEndを待たない）
          if (progressSeq === window._storeeelProgressSeq) {
            startProgressForActive();
          }

          if (currentVideo) {
            currentVideo.style.display = 'none';
          }
        }
      });

      updateCtaButtonAction(currentSlide);

      // 計測とローカルストレージ保存
      let mediaName;
      let mediaId;
      let groupId;
      if (currentVideo) {
        mediaName = currentVideo.getAttribute('media-name');
        mediaId = currentVideo.getAttribute('media-id');
      } else if (currentImage) {
        mediaName = currentImage.getAttribute('media-name');
        mediaId = currentImage.getAttribute('media-id');
      }
      if (window.storeeelItems.frame === "circle") {
        groupId = window.iconId
      } else {
        groupId = null
      }
      trackStoreeelEvent('storeeel_media_asset_view', {
        'storeeel_name':  mediaName,
        'group_id':       groupId,
        'media_id':       mediaId,
        'campaign_id':    window.storeeelItems.id,
      });
      localStorageRepositories.get("mediaView").set(
        mediaId,
        window.storeeelItems.id
      );
    });

    swiper.on('slideChangeTransitionEnd', () => {
      const allSlides = document.querySelectorAll('.storeeel-swiper-group-wrapper .swiper-slide');
      const currentSlide = allSlides[swiper.activeIndex];
      const currentVideo = currentSlide.querySelector('video');

      document.querySelectorAll('.storeeel-swiper-group-wrapper .swiper-slide').forEach(() => {
        // 音量ボタンの状態を確認
        if (currentVideo) {
          checkVolumeButtonState();
        }
      });
      // 通常ケース：transitionEnd到達時にも開始（フォールバックと二重起動しないようにシーケンスで防止）
      startProgressForActive();

      // 自動再生のためのイベントリスナーの再定義
      mobileAutoPlayNextAction();

      // 再生ボタンの状態を必ず停止ボタンにする
      const playButton = document.querySelector('.storeeel-menu-area-icons #start-desktop');
      if (playButton) {
        playButton.src = pauseImg;
        playButton.alt = 'pause';
        playButton.id = 'pause-desktop';
      }
    });
  } else {
    // スライド型の対応(うまく動かなかったため、グループ型と切り分けています。)
    swiper.on('slideChange', (data) => {
      clearImageTimer(); // 画像タイマーをクリア
      const allSlides = document.querySelectorAll('.storeeel-swiper-group-wrapper .swiper-slide');
      const currentSlide = allSlides[data.activeIndex];
      const currentVideo = currentSlide.querySelector('video');
      const currentImage = currentSlide.querySelector('img');
      document.querySelectorAll('.storeeel-swiper-group-wrapper .swiper-slide').forEach((slide) => {
        slide.classList.remove('active');
        const video = slide.querySelector('video');
        if (video && video !== currentVideo) {
          video.pause();
          video.currentTime = 0;
        }
      });
      // 現在のスライドに active クラスを追加し、動画を再生
      currentSlide.classList.add('active');
      if (currentVideo) {
        currentVideo.currentTime = 0;
        window.iconId = currentVideo.getAttribute('group-id');
        const tryPlay = () => {
          currentVideo.removeEventListener('canplay', tryPlay); // 重複防止
          const playPromise = currentVideo.play();
          if (playPromise !== undefined) {
            playPromise
              .then(() => {
                // 進捗バーのアニメーションを開始
                const items = window.storeeelItems;
                let mediaLnegth = 0;
                for(let i = 0; i < swiper.activeIndex; i++){
                  mediaLnegth += items.contentGroups[i].contents.length
                }
                animateCurrentProgressBar(currentVideo.duration, mediaLnegth);
              })
              .catch(() => {
              });
          }
        };

        // すでに再生可能なら即再生、そうでなければイベント待機
        if (currentVideo.readyState >= 3) {
          tryPlay();
        } else {
          currentVideo.addEventListener('canplay', tryPlay);
          currentVideo.load();
        }

        checkVolumeButtonState();
      } else if (currentImage) {
        window.iconId = currentImage.getAttribute('group-id');
        const items = window.storeeelItems;
        let mediaLnegth = 0;
        for(let i = 0; i < swiper.activeIndex; i++){
          mediaLnegth += items.contentGroups[i].contents.length
        }
        animateCurrentProgressBar(5, mediaLnegth);
      }
    });
    swiper.on('slideChangeTransitionEnd', () => {
      mobileAutoPlayNextAction();

      // 再生ボタンの状態を必ず停止ボタンにする
      const playButton = document.querySelector('.storeeel-menu-area-icons #start-desktop');
      if (playButton) {
        playButton.src = pauseImg;
        playButton.alt = 'pause';
        playButton.id = 'pause-desktop';
      }
    });
  }
}
